import moment from 'moment';
import { get } from 'lodash';
import { mapAuthorisersGroup } from '../../utils/authoriserUtils';
import endpoints from '../../utils/endpoints';
import { formatDate, getApproversPayload, getReference, getPaymentInstructionId } from './common';

// TODO: Refactor common code

const getAmount = (payment) => ({
	amount: {
		value: parseFloat(get(payment, 'paymentFxAmount', '0.0')),
		currency: get(payment, 'paymentFxCurrency', 'GBP'),
	},
});

const getBeneficiaryId = (payment) => ({
	beneficiary_id: get(payment, 'beneficiary_id') || get(payment, 'toAccount'),
});

const getPeiId = (payment) => ({
	pei_id: get(payment, 'peiId', ''),
	pei_bulk_id: get(payment, 'peiBulkId', ''),
});

const getCharge = (payment) => ({
	charge: {
		value: get(payment, 'fees', 0.0),
		currency: get(payment, 'matchedCurrency', ''),
	},
});

const getBatchType = (payment) => ({
	batch_type: get(payment, 'batch_type'),
});

export const getContextIdOrID = (payment, isContextIdRequired) => {
	const paymentID = get(payment, 'id');
	return isContextIdRequired ? get(payment, 'context_id', paymentID) : paymentID;
};

export const getChapsRequest = (payment) => {
	const valueDate = payment.valueDate || '';
	const date = moment.isMoment(payment.date) ? formatDate(payment.date) : '';
	const namedApprovers = { approver_id: get(payment, 'authorisers', []).map((authoriser) => authoriser.id) };
	const authorisersGroup = get(payment, 'authorisersGroup', []);
	const mappedAuthorisersGroup = mapAuthorisersGroup(authorisersGroup);
	const groupApprovers = { approval_group_approver_id: mappedAuthorisersGroup };
	const payment_method = get(payment, 'paymentMethod', '');
	const approversPayload = getApproversPayload(namedApprovers, groupApprovers);
	return {
		source_id: payment.id,
		...getBeneficiaryId(payment),
		...getPeiId(payment),
		...getAmount(payment),
		...getCharge(payment),
		submission_date: date,
		value_date: valueDate,
		...getReference(payment),
		...(!!approversPayload && approversPayload),
		...getPaymentInstructionId(payment),
		payment_method,
	};
};

export const getOneOffChapsPaymentConfirmationRequest = (bankId, payment) => {
	const uri = endpoints.createChapsPayment.resolve(bankId, 'default', payment.fromAccount);
	const { method } = endpoints.createChapsPayment;

	return {
		id: payment.id,
		method,
		uri,
		body: {
			...getChapsRequest(payment),
		},
	};
};

export const getChapsBatchPaymentConfirmationRequest = (
	bankId,
	payment,
	batchName,
	batchId,
	approvers,
	groupAuthorisers = []
) => {
	const uri = endpoints.createChapsPayment.resolve(bankId, 'default', payment.fromAccount);
	const { method } = endpoints.createChapsPayment;
	const valueDate = payment.valueDate || '';
	const date = moment.isMoment(payment.date) ? formatDate(payment.date) : '';
	const payment_method = get(payment, 'paymentMethod', '');
	const namedApprovers = { approver_id: approvers.map((authoriser) => authoriser.id) };
	const mappedAuthorisersGroup = mapAuthorisersGroup(groupAuthorisers);
	const groupApprovers = { approval_group_approver_id: mappedAuthorisersGroup };
	const approversPayload = getApproversPayload(namedApprovers, groupApprovers);

	return {
		id: payment.id,
		method,
		uri,
		body: {
			source_id: payment.id,
			...getBeneficiaryId(payment),
			...getPeiId(payment),
			...getAmount(payment),
			...getCharge(payment),
			submission_date: date,
			value_date: valueDate,
			...getReference(payment),
			batch_id: batchId,
			batch_name: batchName,
			...(!!approversPayload && approversPayload),
			...getPaymentInstructionId(payment),
			...getBatchType(payment),
			payment_method,
		},
	};
};
